module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-about-office",
    attrs: {
      "id": "office"
    }
  }, [_c('div', {
    staticClass: "custom-about-office__container"
  }, [_c('div', {
    staticClass: "custom-about-office__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-about-office__row"
  }, [_c('div', {
    staticClass: "custom-about-office__left"
  }, [_c('div', {
    staticClass: "custom-about-office__tabsnamelist"
  }, [_c('input', {
    attrs: {
      "id": "tab1",
      "type": "radio",
      "name": "tab",
      "checked": "checked"
    }
  }), _c('label', {
    attrs: {
      "for": "tab1"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.tabname1)
    }
  }), _c('input', {
    attrs: {
      "id": "tab2",
      "type": "radio",
      "name": "tab"
    }
  }), _c('label', {
    attrs: {
      "for": "tab2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.tabname2)
    }
  }), _c('div', {
    staticClass: "custom-about-office__tabscontentbox"
  }, [_c('swiper', {
    staticClass: "custom-about-office__slider",
    attrs: {
      "id": "tabc1",
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.slides), function(slide, i) {
    return _c('swiperSlide', {
      key: i,
      staticClass: "custom-about-office__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })
  }), _c('div', {
    staticClass: "custom-about-office__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _c('div', {
    staticClass: "custom-about-office__next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-01"
    }
  })], 1), _c('div', {
    staticClass: "custom-about-office__prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-01"
    }
  })], 1)], 2), _c('swiper', {
    staticClass: "custom-about-office__slider",
    attrs: {
      "id": "tabc2",
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.slides2), function(slide, i) {
    return _c('swiperSlide', {
      key: i,
      staticClass: "custom-about-office__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })
  }), _c('div', {
    staticClass: "custom-about-office__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _c('div', {
    staticClass: "custom-about-office__next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-01"
    }
  })], 1), _c('div', {
    staticClass: "custom-about-office__prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-01"
    }
  })], 1)], 2)], 1)])]), _c('div', {
    staticClass: "custom-about-office__right"
  }, [_c('div', {
    staticClass: "custom-about-office__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da11445","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-about-office/custom-about-office.pug
// module id = 728
// module chunks = 1